import LoadingIndicator from "src/components/LoadingIndicator";

export default function Uploading({
  progress
}: {
  progress: number;
}): JSX.Element {
  return (
    <LoadingIndicator
      progress={progress}
      message={
        <>
          <span>Uploading ({(progress * 100).toFixed(1)}%)...</span>
          <br />
          <em>Do not leave this page</em>
        </>
      }
    />
  );
}
